import { Loader } from '@mantine/core';
import type { AggregateItem, AggregateResult } from '@ayocore/platform/common/types/aggregate';
import styles from './AggregateDisplay.module.css';

interface AggregateDisplayProps {
  data?: AggregateResult;
  config?: AggregateItem[];
  total: number;
  loading?: boolean;
  /** Количество выделенных строк (учитывая другие страницы). Если 0 — не показывается. */
  selectedCount?: number;
}

/**
 * Отображает счётчик строк и результаты серверной агрегации в зоне пагинации.
 * Формат: «label: значение» через разделитель.
 * Пока агрегаты загружаются (loading=true) — показывает спиннер вместо значений.
 * Если selectedCount > 0 — показывает дополнительный бейдж «Выделено».
 */
export default function AggregateDisplay({
  data,
  config,
  total,
  loading,
  selectedCount,
}: AggregateDisplayProps) {
  return (
    <div className={styles.container}>
      <span className={styles.item}>
        <span className={styles.label}>Строк:</span>{' '}
        <span className={styles.rowCountBadge}>{total.toLocaleString('ru-RU')}</span>
      </span>
      {selectedCount && selectedCount > 0 ? (
        <span className={styles.item}>
          <span className={styles.label}>Выделено:</span>{' '}
          <span className={styles.selectedCountBadge}>{selectedCount.toLocaleString('ru-RU')}</span>
        </span>
      ) : null}
      {config?.map(({ fn, field, label, color }) => {
        const key = `${fn}_${field}`;
        const displayLabel = label ?? field;

        return (
          <span key={key} className={styles.item}>
            <span className={styles.label}>{displayLabel}:</span>{' '}
            {loading ? (
              <Loader size={10} color='dimmed' />
            ) : (
              <span
                className={color ? styles.valueBadge : styles.value}
                style={color ? { backgroundColor: color } : undefined}
              >
                {data?.[key] != null
                  ? data[key].toLocaleString('ru-RU', { maximumFractionDigits: 2 })
                  : '—'}
              </span>
            )}
          </span>
        );
      })}
    </div>
  );
}
